import { render, staticRenderFns } from "./MyEpoint.vue?vue&type=template&id=28cd1864&scoped=true"
import script from "./MyEpoint.vue?vue&type=script&lang=js"
export * from "./MyEpoint.vue?vue&type=script&lang=js"
import style0 from "./MyEpoint.vue?vue&type=style&index=0&id=28cd1864&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28cd1864",
  null
  
)

export default component.exports